import { useMediaQuery, useTheme } from "@mui/material";

/**
 * @returns whether we are on a mobile display
 */
export const IsMobile = () => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down("sm"));
};
